module.exports = __webpack_public_path__ + "static/img/day4.4b05d05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/day4.jpg
// module id = ZWYJ
// module chunks = 0